/* eslint-disable */
/* eslint-disable import/prefer-default-export */
export const MODE = {
  FULL: 'full',
  MINI: 'mini',
}
